import { useHistory } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { UserDataForm, UserFilters } from '../../app/models/User';

import DefaultCard from '../../components/default/DefaultCard';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import PageHeader from '../../components/PageHeader/PageHeader';
import '../../styles/page-components.css';

import { ServiceResponse } from '../../app/services/shared/interfaces';
import useUserService from '../../app/services/hooks/useUserService';
import DefaultModal from '../../components/default/DefaultModal';
import UserCreate from './components/UserCreate';
import UserEdit from './components/UserEdit';
import { AppContext } from '../../contexts/AppContext';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import UserDataTable from './components/tables/UserDataTable';
import { toast } from 'react-toastify';
import UserPasswordEdit from './components/UserPasswordEdit';
import useNavigationPage from '../../hooks/useNavigationPage';
import ButtonGeneral from '../../components/buttons/ButtonGeneral';
import UserMembershipManager from './components/UserMembershipManager';

const breadcrumbs = [
    { label: 'Inicio', path: '/intranet' },
    { label: 'Usuarios', isCurrent: true }
];

const User = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const history = useHistory();
    const { fetchingGetUsers, getUsers, activeUser } = useUserService();

    const { auth } = useContext(AuthContext);

    const [userIdEdit, setUserIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);

    const [userPasswordIdEdit, setUserPasswordIdEdit] = useState<number>(-1);
    const [showingPasswordEdit, setShowingPasswordEdit] = useState(false);
    const [users, setUsers] = useState<UserDataForm[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const { navigationPage } = useNavigationPage();

    const [showingCreate, setShowingCreate] = useState(false);

    // Estado para modal de membresía
    const [showingMembership, setShowingMembership] = useState(false);
    const [membershipUserId, setMembershipUserId] = useState<number>(-1);
    const [membershipUserName, setMembershipUserName] = useState<string>('');

    const [filter, setFilter] = useState<UserFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
        rut: '',
        first_name: '',
        last_name: '',
        second_last_name: ''
    });

    useEffect(() => {
        reloadTable();
    }, [filter.page, filter.per_page, filter.sort, filter.order]);

    const reloadTable = () => {
        getUsers(filter, {
            onSuccess: (response: ServiceResponse) => {
                setUsers(response.data.users);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/intranet');
                }
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (UserId: number) => {
        setShowingEdit(true);
        setUserIdEdit(UserId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setUserIdEdit(-1);
    };

    const onError = () => {
        setShowingEdit(false);
        setUserIdEdit(-1);
    };

    const showPasswordEdit = (UserId: number) => {
        setShowingPasswordEdit(true);
        setUserPasswordIdEdit(UserId);
    };

    const hidePasswordEdit = () => {
        setShowingPasswordEdit(false);
        setUserPasswordIdEdit(-1);
    };

    const showMembership = (userId: number, userName: string) => {
        setShowingMembership(true);
        setMembershipUserId(userId);
        setMembershipUserName(userName);
    };

    const hideMembership = () => {
        setShowingMembership(false);
        setMembershipUserId(-1);
        setMembershipUserName('');
    };

    // const destroy = (userId: number) => {
    //     const _text = 'Está a punto de eliminar el usuario #' + userId;
    //
    //     useReactConfirmAlert().requestConfirmation({
    //         title: '¿Estás seguro?',
    //         message: _text,
    //         buttons: {
    //             confirmButton: {
    //                 label: 'Si, confirmar',
    //                 onClick: () => {
    //                     if (showLoading) showLoading('loading', 'Eliminando usuario...');
    //                     deleteUser(userId, {
    //                         onSuccess: (response: ServiceResponse) => {
    //                             if (hideLoading) hideLoading();
    //                             // useSweetAlert().successAlert({
    //                             //     title: 'Éxito',
    //                             //     text: response.message
    //
    //                             // });
    //                             useReactConfirmAlert().successAlert({
    //                                 title: 'Éxito',
    //                                 message: response.message
    //                             });
    //                             // if(changeAnimation)changeAnimation('success', response.message, true);
    //                             reloadTable();
    //                         },
    //                         onError: (response: ServiceResponse) => {
    //                             if (hideLoading) hideLoading();
    //
    //                             useReactConfirmAlert().errorAlert({
    //                                 title: 'Error',
    //                                 message: response.message
    //                             });
    //                         }
    //                     });
    //                 }
    //             },
    //             cancelButton: {
    //                 label: 'No, cancelar',
    //                 onClick: () => {
    //                     setTimeout(() => {
    //                         useReactConfirmAlert().infoAlert({
    //                             title: 'Cancelado',
    //                             message: 'El usuario no se ha eliminado.'
    //                         });
    //                     }, 0);
    //                 }
    //             }
    //         }
    //     });
    //
    // };

    const active = (userId: number, active: boolean) => {
        activeUser(userId, active, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                reloadTable();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return (
        <>
            <div className="container-fluid">
                <div className="page-container">
                    {/* Header con breadcrumbs */}
                    <PageHeader
                        title=""
                        breadcrumbs={breadcrumbs}
                    />

                    {/* Header con título y botón de crear alineados */}
                    <DefaultCard>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h1 className="page-title">Gestión de Usuarios</h1>
                                <p className="page-description">
                                    Administra los usuarios del sistema, sus roles y permisos.{" "}
                                    <a href="#" className="description-link">
                                        Conoce más sobre la gestión de usuarios aquí
                                    </a>
                                </p>
                            </div>
                            <ButtonGeneral
                                onClick={showCreate}
                                title="Nuevo usuario"
                                variant="primary"
                                size="small"
                                icon="fa-plus"
                                iconPosition="left"
                            />
                        </div>

                        {/* Data Table */}
                        <UserDataTable
                            active={active}
                            users={users}
                            totalRows={totalRows}
                            loading={fetchingGetUsers}
                            edit={showEdit}
                            editPassword={showPasswordEdit}
                            editMembership={showMembership}
                            filter={filter}
                            setFilter={setFilter}
                            callbackSuccess={reloadTable}
                            onSearch={reloadTable}
                        />
                    </DefaultCard>
                </div>
            </div>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear usuario"
                    backdrop={true}
                    showFooter={false}
                >
                    <UserCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar Usuario"
                    backdrop={true}
                    showFooter={false}
                >
                    <UserEdit
                        userId={userIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={onError}
                    />
                </DefaultModal>
            ) : null}

            {showingPasswordEdit ? (
                <DefaultModal
                    show={showingPasswordEdit}
                    handleClose={hidePasswordEdit}
                    title="Editar contraseña"
                    backdrop={true}
                    showFooter={false}
                >
                    <UserPasswordEdit
                        userId={userPasswordIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hidePasswordEdit();
                        }}
                        onCancel={hidePasswordEdit}
                        onError={hidePasswordEdit}
                    />
                </DefaultModal>
            ) : null}

            {showingMembership ? (
                <DefaultModal
                    show={showingMembership}
                    handleClose={hideMembership}
                    title={`Membresía de ${membershipUserName}`}
                    backdrop={true}
                    showFooter={false}
                >
                    <UserMembershipManager
                        userId={membershipUserId}
                        userName={membershipUserName}
                        onClose={hideMembership}
                        onSuccess={reloadTable}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default User;
